import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { Checkbox, Grid } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setcheckListDatail } from '../../slice/checkListSlice';

export default function CheckListAccordian({ option, disabled = false }) {
  const [options, setOptions] = React.useState(option?.specialityChecklist);
  const [selectedButtons, setSelectedButtons] = React.useState(options.map(() => []));
  const [checked, setChecked] = React.useState(null);
  const [accordian, setAccordian] = React.useState(null);

  const dispatch = useDispatch();

  const checkButton = (accordionIndex, buttonIndex, optionIndex) => {
    if (disabled) return;
    setSelectedButtons(prev => {
      const updated = [...prev];
      const optionSelected = updated[accordionIndex] || [];
      optionSelected[optionIndex] = buttonIndex;
      updated[accordionIndex] = optionSelected;
      return updated;
    });

    setOptions(prevOptions => {
      const updatedOptions = [...prevOptions];
      const updatedChecklistOptions = updatedOptions[accordionIndex].checklistOptions.map((item, index) => {
        if (index === optionIndex) {
          return { ...item, answer: JSON.stringify(buttonIndex + 1) };
        }
        return item;
      });

      updatedOptions[accordionIndex] = {
        ...updatedOptions[accordionIndex],
        checklistOptions: updatedChecklistOptions
      };

      dispatch(setcheckListDatail(updatedOptions));
      return updatedOptions;
    });
  };

  const handleClickChange = (index, accordionIndex) => {
    if (disabled) return;
    setChecked(index);
    setAccordian(accordionIndex);

    setSelectedButtons(prev => {
      const updated = [...prev];
      const optionSelected = updated[accordionIndex] || [];
      optionSelected.fill(index); 
      updated[accordionIndex] = optionSelected;
      return updated;
    });

    setOptions(prevOptions => {
      const updatedOptions = [...prevOptions];
      const updatedChecklistOptions = updatedOptions[accordionIndex].checklistOptions.map((item) => {
        return { ...item, answer: JSON.stringify(index + 1) }; 
      });

      updatedOptions[accordionIndex] = {
        ...updatedOptions[accordionIndex],
        checklistOptions: updatedChecklistOptions
      };

      dispatch(setcheckListDatail(updatedOptions));
      return updatedOptions;
    });
  };

  return (
    <div>
      {options?.map((item, accordionIndex) => (
        <Accordion key={accordionIndex}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel-${accordionIndex}-content`}
            id={`panel-${accordionIndex}-header`}
            sx={{ py: 2 }}
          >
            <Typography
              sx={{
                fontSize: '16px',
                color: 'rgba(0,0,0,0.87)',
                fontWeight: 700
              }}
            >
              {item?.checklistTtile}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container display={'flex'} alignItems={'center'}>
              <Grid item lg={9}></Grid>
              <Grid item lg={3} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {['1', '2', '3', '4'].map((row, i) => (
                  <Checkbox
                    key={i}
                    disableRipple
                    disableFocusRipple
                    disabled={disabled}
                    checked={checked === i && accordian === accordionIndex}
                    onChange={() => !disabled && handleClickChange(i, accordionIndex)} // Update button states when checkbox is clicked
                    sx={{
                      '&.Mui-checked': {
                        color: '#6ebe44 !important'
                      },
                      '&:focus': {
                        outline: 'none'
                      },
                      '&.Mui-disabled': {
                        color: 'rgba(0,0,0,0.26)'
                      }
                    }}
                  />
                ))}
              </Grid>
            </Grid>

            {item?.checklistOptions?.map((itemValue, optionIndex) => (
              <Grid container display={'flex'} alignItems={'center'} key={optionIndex}>
                <Grid container>
                  <Grid item lg={9}>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        color: 'rgba(0,0,0,0.87)',
                        fontWeight: 400
                      }}
                    >
                      {itemValue?.checklistOption}
                    </Typography>
                  </Grid>
                  <Grid item lg={3}>
                    <Grid item lg={12} mt={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      {['1', '2', '3', '4'].map((button, buttonIndex) => (
                        <Button
                          key={buttonIndex}
                          disabled={disabled}
                          style={
                            selectedButtons[accordionIndex]?.[optionIndex] === buttonIndex
                              ? { background: '#6cb94c' }
                              : {}
                          }
                          onClick={() => !disabled && checkButton(accordionIndex, buttonIndex, optionIndex)}
                          sx={{ 
                            borderRadius: '50%', 
                            border: '1px solid gray', 
                            minWidth: '25px', 
                            height: '25px',
                            '&.Mui-disabled': {
                              color: selectedButtons[accordionIndex]?.[optionIndex] === buttonIndex ? 'white' : 'rgba(0,0,0,0.6)',
                              background: selectedButtons[accordionIndex]?.[optionIndex] === buttonIndex ? '#6cb94c' : 'transparent'
                            }
                          }}
                        >
                          {button}
                        </Button>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
